// ============================================================================
// CHANGO V5.0 — Customer create page
// ============================================================================
// Mount: /app/customers/new
// ============================================================================

import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { api } from '../../api/client.js';
import CustomerForm from './CustomerForm.jsx';

export default function CustomerNew() {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [loadingGroups, setLoadingGroups] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/api/customer-groups');
        if (!cancelled) setGroups(Array.isArray(res?.items) ? res.items : []);
      } catch (err) {
        if (!cancelled) setError(err?.message || '加载客户分组失败');
      } finally {
        if (!cancelled) setLoadingGroups(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const createCustomer = useCallback(async (payload) => {
    setSaving(true);
    setError(null);
    try {
      const res = await api.post('/api/customers', payload);
      const id = res?.id;
      if (Number.isInteger(id) && id > 0) {
        navigate(`/app/customers/${id}`, { replace: true });
      } else {
        navigate('/app/customers', { replace: true });
      }
    } catch (err) {
      setError(err?.message || '创建客户失败');
      throw err;
    } finally {
      setSaving(false);
    }
  }, [navigate]);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <header className="mb-4 flex items-center justify-between">
        <div>
          <Link to="/app/customers" className="text-xs text-slate-500 hover:text-chango-700">
            ← 返回客户列表
          </Link>
          <h1 className="mt-1 text-xl font-semibold text-slate-800">新建客户</h1>
        </div>
      </header>

      {error && (
        <div className="mb-4 rounded-md border border-rose-200 bg-rose-50 px-4 py-2 text-sm text-rose-800">
          {error}
        </div>
      )}

      {loadingGroups ? (
        <div className="p-6 text-sm text-slate-500">加载中...</div>
      ) : (
        <CustomerForm
          groups={groups}
          saving={saving}
          submitLabel="创建客户"
          onCancel={() => navigate('/app/customers')}
          onSubmit={createCustomer}
        />
      )}
    </div>
  );
}
